import React from 'react';

import { BaseIconProps } from './';

export const Lock = ({ fill }: BaseIconProps) => (
  <path
    transform="matrix(2.5471698,0,0,-2.5471698,-112.07547,1209.9057)"
    d="m 405,291 c 1,9 2,18 2,28 0,86 -68,156 -151,156 -83,0 -151,-70 -151,-156 0,-10 1,-19 2,-28 C 94,283 85,268 85,251 V 99 c 0,-26 21,-48 47,-48 h 248 c 26,0 47,22 47,48 v 0 152 c 0,17 -9,32 -22,40 z M 277,158 v -33 c 0,-12 -9,-21 -21,-21 -12,0 -21,9 -21,21 v 33 c -13,7 -22,21 -22,38 0,24 19,43 43,43 24,0 43,-19 43,-43 0,-17 -9,-31 -22,-38 z m 73,140 H 162 c -1,7 -2,14 -2,21 0,55 43,100 96,100 53,0 96,-45 96,-100 0,-7 -1,-14 -2,-21 z"
    fill={fill}
  />
);
